import React from 'react';
import { Box, Typography, Theme } from '@mui/material';
import ETOButton from '../../components/Button/ETOButton';

interface ErrorPageProps {
  buttonText?: string;
  icon?: React.ReactNode;
  reason: string;
  onClick?: () => void;
  warning: string;
}

const root = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
};

const container = (theme: Theme) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: theme.spacing(3),
  width: '90%',
  maxWidth: theme.spacing(70),
});

const ErrorPage: React.FC<React.PropsWithChildren<ErrorPageProps>> = (props) => {
  const {
    icon, reason, onClick, buttonText, warning,
  } = props;

  return (
    <Box sx={root}>
      <Box sx={container}>
        {icon}
        <Typography
          align="center"
          data-testid="warning"
          variant="h3"
          color="textPrimary"
        >
          {warning}
        </Typography>
        <Typography
          align="center"
          color="textSecondary"
          data-testid="reason"
          variant="body1"
          paragraph
        >
          {reason}
        </Typography>
        {
          buttonText && (
            <ETOButton
              color="primary"
              data-testid="button"
              size="medium"
              onClick={() => onClick && onClick()}
            >
              {buttonText}
            </ETOButton>
          )
        }

      </Box>
    </Box>
  );
};

export default ErrorPage;
